import { formatCouponRateWithNotation } from "./couponRateFormatter";

// LQC-2909 - display carries the %, the colDef's valueFormatter does not.
const CouponRateCellRenderer = (params: any) => {
  return (
    <div
      className="text-center"
      data-testid="CouponRateCellContainer"
      id="CouponRateCellContainer"
      style={{ width: "100%" }}
    >
      {formatCouponRateWithNotation(params.value)}
    </div>
  );
};

export default CouponRateCellRenderer;
